import { mutatorAction } from 'satcheljs';
import type { ClientItem } from 'owa-mail-store';

export const setMayHaveStaleBodyMutator: (item: ClientItem, mayHaveStaleBody: boolean) => void =
    mutatorAction('setMayHaveStaleBody', (item: ClientItem, mayHaveStaleBody: boolean): void => {
        item.mayHaveStaleBody = mayHaveStaleBody;
    });
